import React, { useState, useEffect } from 'react';
import './IvMeasurementInverterInfo.css';
// import Navbar from '../../public/Navbar';
import '../../App.css';
import {  useSelector } from 'react-redux';
import { formatPower } from '../../public/formatPower'; // 유틸리티 함수 불러오기
import useIsRemsIv from '../../hooks/useIsRemsIv';
import useIsOcipIv from '../../hooks/useIsOcipIv';
import useIsGrowattIv from '../../hooks/useIsGrowatt';
import useIsMobile from '../../hooks/useIsMobile';




const IvMeasurementInverterInfo = ({ SelInverter }) => {

  const isMobile = useIsMobile();
  

  const Iv_list = useSelector((state) => state.Iv_list || {});
  const ivData = useSelector((state) => state.ivData || {});

  
  const [index, Setindex] = useState([]);
  const [Grid_Power, SetGrid_Power] = useState(0);
  const [Add_TodayPower, SetAdd_TodayPower] = useState(0);
  const [Add_power, SetAdd_power] = useState(0);
  const [Con_Eff, SetCon_Eff] = useState(0);




  useEffect(() => {
  
    if (Iv_list.seq && Array.isArray(Iv_list.seq)) {
      Iv_list.seq.forEach((seq, key) => {
        if (SelInverter === seq) {
          Setindex(key);
        }
      });
    }  
  }, [Iv_list, SelInverter]); // 의존성 배열에 Iv_list와 SelInverter를 넣습니다.

  const isRems = useIsRemsIv(SelInverter);
  const isOcip = useIsOcipIv(SelInverter);
  const isGrowatt = useIsGrowattIv(SelInverter);


  useEffect(() => {
    const currentGridPower = ivData.Grid_Power[index];  // 복잡한 표현식을 분리
    const currentAddPower = ivData.Add_power[index];    // 복잡한 표현식을 분리
    const todayAdd = ivData.todayAdd[index];    // 복잡한 표현식을 분리


    SetGrid_Power(formatPower(currentGridPower, "Real"));
    SetAdd_power(formatPower(currentAddPower, "Add"));
    SetAdd_TodayPower(formatPower(todayAdd, "Real"));

    

  }, [index, ivData.todayAdd, ivData.Add_power, ivData.Grid_Power]);  // 배열 전체를 의존성에 추가
  
  useEffect(() => {
    const gridPower = ivData.Grid_Power?.[index];

    // ✅ 1. REMS 방식: PvPower 기반 계산
    if (!(isOcip || isGrowatt)) {
      const pvPower = ivData.PvPower?.[index];

      if (pvPower && gridPower && pvPower > 0) {
        let efficiency = (gridPower / pvPower) * 100;
        if (efficiency > 99.9) efficiency = 99.9;
        if (efficiency < 0 || isNaN(efficiency)) efficiency = 0;
        SetCon_Eff(efficiency.toFixed(1));
      } else {
        SetCon_Eff(0);
      }
    }

    // ✅ 2. OCIP 방식: Mppt 전압 * 전류로 직접 계산
    else {
      const mpptCurrents = ivData.Mppt_Current?.[index] || [];
      const mpptVolts = ivData.Mppt_Volt?.[index] || [];

      if (mpptCurrents.length > 0 && mpptVolts.length > 0 && gridPower !== undefined) {
        let totalDcPower = 0;

        for (let i = 0; i < mpptCurrents.length; i++) {
          const volt = mpptVolts[i];
          const curr = mpptCurrents[i];

          if (volt > 0 && curr > 0) {
            const v = volt / 10;   // 0.1V 단위
            const c = curr / 100;  // 0.01A 단위
            totalDcPower += v * c;
          }
        }

        let efficiency = totalDcPower > 0 ? (gridPower / totalDcPower) * 100 : 0;
        if (efficiency > 99.9) efficiency = 99.9;
        if (efficiency < 0 || isNaN(efficiency)) efficiency = 0;
        SetCon_Eff(efficiency.toFixed(1));
      } else {
        SetCon_Eff(0);
      }
    }
  }, [
    SelInverter,
    ivData.PvPower,
    ivData.Mppt_Current,
    ivData.Mppt_Volt,
    ivData.Grid_Power,
    index,
  ]);


  return (

    <div>
      <div style={{ margin: '10px', maxWidth: '800px' }}>
        <div className='inverterGenInfo-TopBox'>
          <div style={{ color: '#6B7476', fontSize: isMobile? '17px':'20px', fontWeight: '600', paddingLeft: '20px' }}>◎ {Iv_list.iv_name[index]} </div>
          <div style={{ flexGrow: '1' }}></div>
          <div style={{ color: '#6B7476', fontSize: isMobile? '17px':'20px', fontWeight: '600', paddingRight: '20px' }}>⦁ ⦁ ⦁</div>
        </div>
        <div className='inverterGenInfo-BottomBox'>
          <div className="container">
            <div className="header">
              <div className="inverterGenInfo-title-text-Container">
                <div className="inverterGenInfo-title-textBox font-small">
                  <span>현재 발전량</span>
                  <span className="value">{Grid_Power.value}</span>
                  <span className="unit">{Grid_Power.unit}</span>
                </div>
                <div className="inverterGenInfo-title-textBox font-small">
                  <span>금일 발전량</span>
                  <span className="value">{Add_TodayPower.value}</span>
                  <span className="unit">{Add_TodayPower.unit}</span>
                </div>
                <div className="inverterGenInfo-title-textBox font-small">
                  <span>변환효율</span>
                  <span className="value">{Con_Eff}</span>
                  <span className="unit">%</span>
                </div>
                <div className="inverterGenInfo-title-textBox font-small">
                  <span>누적 발전량</span>
                  <span className="value" style={{color:'#2CBB7E'}}>{Add_power.value}</span>
                  <span className="unit" style={{color:'#2CBB7E'}}>{Add_power.unit}</span>
                </div>
              </div>
            </div>
            <table className="data-table" style={isOcip ? { marginBottom: '54px' } : { marginBottom: '10px' }}>
              <thead>
                <tr style={{backgroundColor:'#B1BCC9', color:'white'}}>
                  <th rowSpan="2" style={{ borderTopLeftRadius: '5px' }}>항목</th>
                  {isRems && (<th rowSpan="2">DC</th>)}
                  <th colSpan="4" style={{ borderTopRightRadius: '5px' }}>AC</th>
                </tr>
                <tr style={{backgroundColor:'#B1BCC9', color:'white'}}>
                  <th>R</th>
                  <th>S</th>
                  <th>T</th>
                </tr>
              </thead>
              <tbody style={{fontSize: isMobile? '15px':'20px'}}>
                <tr>
                  <td style={{backgroundColor:'#E7EDF2', color:'#8a8a97', fontWeight:'600'}}>전압 (V)</td>
                  {isRems && (<td>{(ivData.PvTotalVolt?.[index] / 10).toFixed(1)}</td>)}
                  <td>{(ivData.Grid_RS_Volt[index]/10).toFixed(1)}</td>
                  <td>{(ivData.Grid_ST_Volt[index]/10).toFixed(1)}</td>
                  <td>{(ivData.Grid_TR_Volt[index]/10).toFixed(1)}</td>
                </tr>
                <tr>
                  <td style={{backgroundColor:'#E7EDF2', color:'#8a8a97', fontWeight:'600'}}>전류 (A)</td>
                  {isRems && (<td>{(ivData.PvTotalCurrent[index]/10).toFixed(1)}</td>)}
                  <td>{(ivData.Grid_R_Current[index]/10).toFixed(1)}</td>
                  <td>{(ivData.Grid_S_Current[index]/10).toFixed(1)}</td>
                  <td>{(ivData.Grid_T_Current[index]/10).toFixed(1)}</td>
                </tr>
                {!isOcip && (<tr>
                  <td style={{backgroundColor:'#E7EDF2', color:'#8a8a97', fontWeight:'600', borderBottomLeftRadius: '5px'}}>전력 (kW)</td>
                  {isRems && (<td>{(ivData.PvPower[index]/1000).toFixed(2)}</td>)}
                  <td colspan="3" style={{ borderBottomRightRadius: '5px'}}>{(ivData.Grid_Power[index]/1000).toFixed(2)}</td>
                </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};







export default IvMeasurementInverterInfo;
